<template>
  <div class="modal" @click="closeNoteModal()">
    <div class="modal-content" @click.stop=";" v-if="attachment && attachment.resourceObj">
      <div class="title">{{ attachment.resourceObj.title }}</div>
      <textarea v-model="attachment.resourceObj.tempText" name="noteText" id="noteText" class="noteText" cols="55" rows="15"></textarea>
      <button v-on:click.stop="closeNoteModal()" class="button is-pulled-left">Cancel</button>

      <div class="is-pulled-right">
        <button v-on:click.stop="deleteMode = true" v-if="attachmentId !== 'new'" class="button">Delete</button> 
        <button v-on:click.stop="upsertNote()" class="button is-primary">{{attachmentId === 'new' ? 'Save' : 'Update'}}</button>
      </div>
    </div>
    <!-- Delete Modal -->
    <div v-if="deleteMode" class="modal no-select">
      <div class="modal-content">
          <h3 class="has-text-left">Confirm deletion</h3>
          <p class="has-text-left">Are you sure you want to delete this annotation? It will be deleted permanently.</p>
        <div class="modal-buttons is-pulled-right">
          <button class="button is-primary no-button" v-on:click.stop="deleteMode = false">No</button>
          <button  v-on:click.stop="deleteNote()" class="button yes-button">Yes</button> 
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import storeHelpers from '@/utils/storeHelpers.js';
import utils from '@/utils/utils.js';
import annotationUtils from '@/utils/annotationUtils.js';

export default {
  name: 'Note',
  props: {
    contextMenuOptions: {
      type: Object,
      required: true
    },
    attachmentId: {
      type: String,
      required: true
    }
  }, 
  data() {
    return {
      attachment: undefined,
      deleteMode: false
    }
  },
  mounted() {
    utils.log(this, "contextMenuOptions:", this.contextMenuOptions);
    this.attachment = annotationUtils.getOrCreateAttachment(this, this.attachmentId, this.contextMenuOptions, 'note');

    if(this.attachment.resourceObj.base64text) {
      this.attachment.resourceObj.tempText = atob(this.attachment.resourceObj.base64text)
    }

    var t = this;
    document.addEventListener("keydown", function(e) {
      if (e.keyCode === 27) {
        t.closeNoteModal();
      }
    });
  },
  methods: {
    closeNoteModal: function() {
      this.$emit("noteModalClosed", false);
    },
    upsertNote: function() {
      const resource = this.attachment.resourceObj;
      var tempText = resource.tempText;

      // update title and base64 of text
      resource.title = tempText.replaceAll("\n", " ").replaceAll("\r", " ").limit(30);
      resource.base64text = btoa(tempText);

      annotationUtils.upsertAnnotation(this, this.attachmentId, this.attachment, resource);

      this.closeNoteModal();
    },
    deleteNote: function() {
      annotationUtils.deleteAnnotation(this, this.attachment);
      this.closeNoteModal();
    }
  }
}
</script>
<style scoped lang="scss">
@import "src/css/vars.scss";

.title {
  font-size: 20px;
}

.noteText {
  margin-bottom: 10px;
  resize: none;
}

.modal-content {
  width: 440px !important;
  margin-top: 12%;
}
</style>

